<template>
  <v-container>
    <h1>{{ $t('labels.e-book-label-secondary') }}</h1>

    <template v-if="(isInstructor(0) || isCompanyUser(0)) && apprentices.length > 0">
      <!-- <h4 class="pt-4" v-if="isInstructor(0)">{{ $t('labels.my-apprentice') }}</h4> -->
      <div class="pb-8" v-for="apprentice in apprentices" :key="apprentice.id">
        <h6 class="text-uppercase mb-0 pt-2" style="line-height: 18px">
          {{ `${apprentice.person.firstName} ${apprentice.person.lastName}` }}
        </h6>
        <div class="mb-8">
          <BasicEducationTimeItem
            :education="apprentice"
            :instructors="getApprenticeshipInstructors(apprentice)"
          />
          
          <ActionButton v-if="isAdminUser(0) && extendEducationButtonVisible(apprentice) && !isExtensionApproved(apprentice)"
            actionIcon="$sl-stairs-ascend"
            type="application"
            @click="changeBasicEducationTime(apprentice)"
            :isDisabled="isImitatingUser()"
          >{{ $t("labels.change-basic-education-time-btn") }}</ActionButton>
          
          <MessageBox class="my-5" type="info" v-if="isExtensionApproved(apprentice)">
            <h5>{{ $t("ebook.approved-extension-headline") }}</h5>
            <p class="pr-2">
              {{
                $t("ebook.approved-extension-approvedAt", {
                  date: extensionApprovedAt(apprentice.education.educationExtensions[0].approvedAt)
                })
              }}
            </p>
          </MessageBox>
        </div>
      </div>
    </template>

    <div class="pt-8" v-if="apprentices.length > 0">
      <p class="explanation">{{ $t('qualifying.meter-explanation') }}</p>
    </div>

    <PersonBasicEducationTimeModal
      :apprentice="apprentice"
      :extendedEducationObj="extendedEducationObj"
      :basicEducationExtensionModalVisible="basicEducationExtensionModalVisible"
      @close="basicEducationExtensionModalVisible = false"
    />
  </v-container>
</template>

<script>
import API from '@/services/api.js'
import { mapGetters} from 'vuex'
import ActionButton from "@/components/Common/ActionButton";
import get from 'lodash/get'
import BasicEducationTimeItem from '@/components/Common/BasicEducation/BasicEducationTimeItem.vue';
import PersonBasicEducationTimeModal from './PersonBasicEducationTimeModal.vue';
import MessageBox from '@/components/Common/MessageBox.vue'
import SugarDate from 'sugar/date'

export default {
  name: 'PersonBasicEducationTime',

  components: {
    ActionButton,
    BasicEducationTimeItem,
    PersonBasicEducationTimeModal,
    MessageBox
  },

  data: () => ({
    apprentices: [],
    basicEducationExtensionModalVisible: false,
    extendedEducationObj: null,
    apprentice: null
  }),

  created() {
    this.init()
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isInstructor', 'isCompanyUser', 'isAdminUser', 'isImitatingUser']),

    extendEducationButtonVisible() {
      const approvedAssignments = this.apprentices.filter(a => a.education.educationDistanceEducationProviderCourses.some(e => e.assignments.some(a => a.isApproved)))
      return apprentice => (
        apprentice.bookElementsApprovedCount < apprentice.bookElementsMandatoryCount ||
        !approvedAssignments
      )
    },

    isExtensionApproved() {
      return apprentice => !!apprentice.education.educationExtensions.some(e => e.approved)
    },

    extensionApprovedAt() {
      return approvedAtDate => SugarDate.Date(new Date(approvedAtDate) ?? '-').format("{yyyy}-{MM}-{dd}").raw
    }
  },

  watch: {
    currentUser: {
      handler: function () {
        this.init()
      },
      deep: true
    },
  },

  methods: {
    init() {
      const userId = this.$route.params.id || get(this,'currentUser.id', null)
      if (!userId) return

      if (this.isInstructor() || this.isCompanyUser(0) && !this.$route.params.id) {
        API.listBooks().then(({data = []}) => {
          const filteredApprenticies = data.filter(d => d.personId !== this.currentUser.id)
          this.apprentices = filteredApprenticies
        })
        .catch(error => {
          console.log('Error getting apprenticies QT:', error)
        })
      }
    },

    changeBasicEducationTime(apprentice){
      this.apprentice = apprentice
      const { educationId } = apprentice

      API.getExtendedEducation(educationId).then((response) => {
        this.basicEducationExtensionModalVisible = true
        this.extendedEducationObj = response.data
      })
    },

    getApprenticeshipInstructors({ apprenticeshipId, education }) {
      return get(education, 'apprenticeships', []).filter(({ id }) => id === apprenticeshipId)
        .map(({ apprenticeshipInstructors }) => apprenticeshipInstructors.map(({ instructor }) => instructor)).flat()
    }
  }
}
</script>
